import React from 'react';

import { WelcomeCodeRequiredModal } from 'components/rewards/referral/WelcomeCodeRequiredModal';
import { CODE_REQUIRED_OVERLAY } from 'config/constants';
import { staticDispatch, useSelector } from 'reduxState/store';
import {
  showDesktopQRConnectModal,
  showWalletModal,
} from 'reduxState/wallet/walletDetailsReducer';

import UnlockCore from './UnlockCore';

function UnlockModal() {
  const isMobile = useSelector(state => state.screen.isMobile);
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const walletDetail = useSelector(state => state.walletDetail);
  const skipDesktopQrConnectModal = useSelector(
    state => state.exchange.userGuide.skipQrConnectModal
  );
  const referralCode = useSelector(
    state => state.currentUserData.userReferral.referralCode
  );
  const bankrollCodeToApply = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeToApply
  );
  const {
    unlockModalDelegationDisabled,
    unlockModalKeepWalletUntilSuccess,
    unlockModalOpen,
    unlockModalAfterGoTo,
    unlockModalSkipCodeScreen,
  } = walletDetail;

  const hasCodeAlready = !!referralCode || !!bankrollCodeToApply;

  const unlockCallback = () => {
    staticDispatch(showWalletModal({ show: false }));
    if (!skipDesktopQrConnectModal && !isMobile) {
      staticDispatch(showDesktopQRConnectModal('standard'));
    }
  };

  if (!unlockModalOpen) {
    return null;
  }

  if (
    CODE_REQUIRED_OVERLAY &&
    !walletAddress &&
    !unlockModalSkipCodeScreen &&
    !hasCodeAlready
  ) {
    return (
      <WelcomeCodeRequiredModal
        onClose={() => staticDispatch(showWalletModal({ show: false }))}
        onProceedToWallet={() =>
          staticDispatch(showWalletModal({ unlockModalSkipCodeScreen: true }))
        }
      />
    );
  }

  return (
    <UnlockCore
      afterUnlockCallback={unlockCallback}
      afterUnlockGoTo={unlockModalAfterGoTo}
      delegationDisabled={unlockModalDelegationDisabled}
      keepWalletUntilSuccess={unlockModalKeepWalletUntilSuccess}
      layout="modal"
    />
  );
}

export default UnlockModal;
